import React, { Component } from "react";
import {
  NormalInput,
  NormalTable,
  NormalButtonBackend,
} from "component/common";
import "./style.scss";
import { AiOutlinePlus, AiOutlineMinus } from "react-icons/ai";
import { commonCreateApi, getCommonApi } from "redux/actions/common";
import { withTranslation } from "react-i18next";
import { PayGroups, NewPayGroups, updateCommon } from "redux/actions/Backend";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Toast } from "service/toast";
import { DragFileUpload } from "../../../../common";

export class PaymentGroupClass extends Component {
  state = {
    CommissionDetails: [
      { label: "Code" },
      { label: "Sequence", divClass: "justify-content-end" },
    ],
    count: null,
    iscreation: false,
    islist: false,
    staffList: [],
    code: null,
    codeedit: null,
    countedit: null,
    edit: false,
    updateId: null,
    images: null,
    image: null,
    editImage: null,
    updateImage: false,
  };

  generalcontent() {
    this.setState({
      iscreation: !this.state.iscreation,
    });
  }

  commissioncontent() {
    this.setState({
      islist: !this.state.islist,
    });
  }

  componentDidMount = () => {
    this.Listofpaygroups({});
  };

  updateState = (data) => {
    if (this.state.isMounted) this.setState(data);
  };

  handleedit = async (itemcode) => {
    console.log(itemcode, "itemCoed");
    let {
      edit,
      codeedit,
      countedit,
      images,
      image,
      temp,
      updateId,
      picTemp,
      editImage,
    } = this.state;
    edit = true;
    this.setState({ edit });
    await this.props.PayGroups().then((res) => {
      // debugger;
      let objIndex = res.findIndex((obj) => obj.payGroupCode == itemcode);
      temp = res[objIndex];
      this.setState({
        temp,
      });
      codeedit = temp.payGroupCode;
      countedit = temp.seq;
      images = temp.pictureLocation;
      updateId = temp.id;
      this.setState({
        codeedit,
        countedit,
        images,
        updateId,
      });
    });
    await this.props.getCommonApi(`paygroupimage/`).then((res) => {
      // debugger;
      let picIndex = res.findIndex((obj) => obj.pay_group_code == itemcode);
      picTemp = res[picIndex];
      this.setState({
        picTemp,
      });
      codeedit = picTemp.pay_group_code;

      editImage = picTemp.picturelocation;
      // updateId = picTemp.id;
      this.setState({
        codeedit,
        // countedit,
        editImage,
        // updateId,
      });
    });
    this.setState({
      iscreation: true,
    });
  };

  handleimageChange = (event) => {
    const displayImage = URL.createObjectURL(event.target.files[0]);

    this.setState({
      images: event.target.files[0],
      image: displayImage,
      updateImage: true,
      editImage: displayImage,
    });
  };
  dataURLtoFile = (dataurl, filename) => {
    var arr = dataurl.split(","),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
  };
  handleupdates = async () => {
    let {
      edit,
      code,
      count,
      codeedit,
      countedit,
      images,
      editImage,
      image,
      updateId,
      updateImage,
    } = this.state;
    let descJson = {
      payGroupCode: codeedit,
      pictureLocation: images,
      seq: countedit,
      iscreditcard: null,
    };
    await this.props
      .updateCommon(
        `PayGroups/update?where=%7B%22id%22%3A%20%22${updateId}%22%7D
    `,
        descJson
      )
      .then((data) => {
        let formData = new FormData();
        if (updateImage) {
          formData.append(`picturelocation`, images);
          formData.append(`paygroup_code`, codeedit);

          this.props
            .commonCreateApi(`paygroupimageupload/`, formData)
            .then((res) => {
              console.log(res, "response");
              this.Listofpaygroups({});
              Toast({
                type: "success",
                message: "Successfully Added",
              });
              code = "";
              count = "";
              images = null;
              this.setState({ code, count, images });
            })
            .catch((e) => console.log(e));
        }

        this.Listofpaygroups({});
        Toast({
          type: "success",
          message: "Updated Successfully",
        });
      });
    edit = false;
    code = "";
    count = "";
    images = "";
    updateImage = false;
    this.setState({ edit, code, count, images, updateImage });
    this.generalcontent();
  };

  Listofpaygroups = async () => {
    this.updateState({ is_loading: true });
    await this.props.PayGroups().then((res) => {
      let { staffList } = this.state;
      staffList = res;
      this.setState({
        staffList,
        is_loading: false,
      });
    });
  };

  temp = ({ target: { value, name } }) => {
    let { code, count } = this.state;
    if (name == "code") {
      code = value;
      this.setState({ code });
    }
    if (name == "count") {
      count = value;
      this.setState({ count });
    }
  };

  handleeditinput = ({ target: { value, name } }) => {
    let { codeedit, countedit } = this.state;
    if (name == "code") {
      codeedit = value;
      this.setState({ codeedit });
    }
    if (name == "count") {
      countedit = value;
      this.setState({ countedit });
    }
  };

  Addnewone = async () => {
    let { code, count, images, image } = this.state;
    if (code == null || count == null) {
      Toast({
        type: "error",
        message: "Please check required ",
      });
    } else {
      let newroom = {
        payGroupCode: code,
        pictureLocation: image,
        seq: count,
        iscreditcard: true,
      };
      await this.props
        .NewPayGroups(newroom)
        .then((res) => {
          // this.sendImage();
          let formData = new FormData();

          formData.append(`picturelocation`, images);
          formData.append(`paygroup_code`, code);

          this.props
            .commonCreateApi(`paygroupimageupload/`, formData)
            .then((res) => {
              console.log(res, "response");
              this.Listofpaygroups({});
              Toast({
                type: "success",
                message: "Successfully Added",
              });
              code = "";
              count = "";
              images = null;
              this.setState({ code, count, images });
            })
            .catch((e) => console.log(e));
          this.Listofpaygroups({});
          Toast({
            type: "success",
            message: "Successfully Added",
          });
          // code = "";
          // count = "";
          // images = null;
          // this.setState({ code, count, images });
        })
        .catch((e) => console.log(e));
    }
    // if (code == null || count == null) {
    //   Toast({
    //     type: "error",
    //     message: "Please check required ",
    //   });
    // } else {

    // }
    this.commissioncontent();
  };

  render() {
    let {
      CommissionDetails,
      staffList,
      is_loading,
      code,
      iscreation,
      islist,
      count,
      codeedit,
      countedit,
      images,
      edit,
      editImage,
      image,
    } = this.state;
    console.log(image, "Image");
    let { t } = this.props;
    return (
      <>
        <div className="container-fluid salespayment bg-white">
          <div className="row">
            <div className="col-12">
              <h4 className="mt-3 label-head text-center text-md-left">
                {t("Payment Group")}
              </h4>
            </div>
          </div>

          {edit == false ? (
            <>
              <div
                className="d-flex  justify-content-between p-3 payment"
                onClick={() => this.generalcontent()}
              >
                <p>{t("Payment Group Creation")}</p>
                <div className="icons">
                  {iscreation == false ? <AiOutlinePlus /> : <AiOutlineMinus />}
                </div>
              </div>
              {iscreation == true ? (
                <div className="container-fluid roomcontent">
                  <div className="row">
                    <div className="col-12 col-md-6">
                      <div className="mt-3">
                        <span>{t("Code")}</span>
                        <span style={{ color: "red" }}>*</span>
                        <div className="input-group">
                          <NormalInput
                            value={code}
                            name="code"
                            onChange={this.temp}
                          />
                        </div>
                      </div>
                      <div className="mt-3">
                        <span>{t("Sequence")}</span>
                        <span style={{ color: "red" }}>*</span>
                        <div className="input-group">
                          <NormalInput
                            value={count}
                            name="count"
                            onChange={this.temp}
                          />
                        </div>
                      </div>
                      <div className="col-12 col-md-6 col-xl-6 col-lg-6 p-0">
                        <div className="mt-4 mb-0">
                          <p>{t("Picture")}</p>
                          <div className="mt-3 ml-2">
                            <input
                              type="file"
                              accept="image/*"
                              // onChange={(e) => {
                              //   if (e.target.value || e.target.value != null) {
                              //     var reader = new FileReader();
                              //     reader.onload = (e) => {
                              //       this.setState({
                              //         image: e.target.result,
                              //       });
                              //     };
                              //     reader.readAsDataURL(e.target.files[0]);
                              //   }
                              // }}
                              onChange={(event) =>
                                this.handleimageChange(event)
                              }
                            />
                          </div>
                        </div>
                        <div className="imagecontainer d-flex justify-content-center justify-content-md-start">
                          <img src={image} alt="" width="100" height="66" />
                        </div>
                      </div>

                      <div className="mt-3 col-12 col-md-4 p-0">
                        <NormalButtonBackend
                          mainbg={true}
                          label={"Add"}
                          onClick={() => this.Addnewone()}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                ""
              )}
            </>
          ) : (
            <>
              <div
                className="d-flex  justify-content-between p-3 payment"
                onClick={() => this.generalcontent()}
              >
                <p>{t("Payment Group Creation")}</p>
                <div className="icons">
                  {iscreation == false ? <AiOutlinePlus /> : <AiOutlineMinus />}
                </div>
              </div>
              {iscreation == true ? (
                <div className="container-fluid roomcontent">
                  <div className="row">
                    <div className="col-12 col-md-6">
                      <div className="mt-3">
                        <span>{t("Code")}</span>
                        <span style={{ color: "red" }}>*</span>
                        <div className="input-group">
                          <NormalInput
                            value={codeedit}
                            name="code"
                            onChange={this.handleeditinput}
                            disabled={true}
                          />
                        </div>
                      </div>
                      <div className="mt-3">
                        <span>{t("Sequence")}</span>
                        <span style={{ color: "red" }}>*</span>
                        <div className="input-group">
                          <NormalInput
                            value={countedit}
                            name="count"
                            onChange={this.handleeditinput}
                          />
                        </div>
                      </div>
                      <div className="col-12 col-md-6 col-xl-6 col-lg-6 p-0">
                        <div className="mt-4 mb-0">
                          <p>{t("Picture")}</p>
                          <div className="mt-3 ml-2">
                            <input
                              type="file"
                              onChange={(event) =>
                                this.handleimageChange(event)
                              }
                            />
                          </div>
                        </div>
                        <div className="imagecontainer d-flex justify-content-center justify-content-md-start">
                          <img src={editImage} alt="" width="100" height="66" />
                        </div>
                      </div>
                      <div className="mt-3 col-12 col-md-4 p-0">
                        <NormalButtonBackend
                          mainbg={true}
                          label={"Update"}
                          onClick={() => this.handleupdates()}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                ""
              )}
            </>
          )}

          <div
            className="d-flex  justify-content-between p-3 payment mt-5"
            onClick={() => this.commissioncontent()}
          >
            <p>{t("Payment Group List")}</p>
            <div className="icons">
              {islist == false ? <AiOutlinePlus /> : <AiOutlineMinus />}
            </div>
          </div>
          {islist == true ? (
            <div>
              <div className="col-12 mt-1">
                <div className="tab-table-content">
                  <h5 className="mt-3 label-head text-center text-md-left">
                    {t("List of Payment Groups")}
                  </h5>
                  <div className="py-4">
                    <div className="table-container">
                      <NormalTable headerDetails={CommissionDetails}>
                        {is_loading ? (
                          <tr>
                            <td colSpan="7">
                              <div class="d-flex mt-5 align-items-center justify-content-center">
                                <div class="spinner-border" role="status">
                                  <span class="sr-only">Loading...</span>
                                </div>
                              </div>
                            </td>
                          </tr>
                        ) : staffList.length > 0 ? (
                          staffList.map(({ payGroupCode, seq }, index) => {
                            return (
                              <tr key={index}>
                                <td>
                                  <div
                                    className="text-left text-primary"
                                    onClick={() =>
                                      this.handleedit(payGroupCode)
                                    }
                                  >
                                    {payGroupCode}
                                  </div>
                                </td>
                                <td>
                                  <div className="text-left">{seq}</div>
                                </td>
                              </tr>
                            );
                          })
                        ) : null}
                      </NormalTable>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            ""
          )}
        </div>
      </>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      PayGroups,
      NewPayGroups,
      updateCommon,
      commonCreateApi,
      getCommonApi,
    },
    dispatch
  );
};

export const PaymentGroup = withTranslation()(
  connect(null, mapDispatchToProps)(PaymentGroupClass)
);
